<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="SysAdminInstanceDetails.saveError">
    <template slot="center">
      <el-form
        :rules="rules"
        :ref="formRef"
        :model="formData"
        :label-position="labelPosition"
        label-width="20em">

        <section>
          <div class="section-items">
            <el-form-item :label="$t('label.caused_by')" prop="status_cause">
              <el-col :span="12">
                <el-select v-model="formData.status_cause" class="w-100" :disabled="!edit || isBlocked">
                  <el-option
                     v-for="item in options"
                    :key="item.key"
                    :label="$t(item.label)"
                    :disabled="item.disabled"
                    :value="item.key">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.comment')" prop="status_comment">
              <el-col :span="18">
                <el-input
                   type="textarea"
                   v-model="formData.status_comment"
                  :disabled="!edit || isBlocked"
                  :placeholder="$t('label.describe_reason_blocking')"
                  :autosize="{ minRows: 3, maxRows: 6 }">
                </el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">
        <el-button
           v-if="isBlocked"
           type="success"
           size="small"
          :loading="isSaving"
          @click="submitForm">
          {{ $t('label.unblock_instance') }}
        </el-button>

        <el-button
           v-else
           type="danger"
           size="small"
          :loading="isSaving"
          @click="submitForm">
          {{ $t('label.block_instance') }}
        </el-button>

        <el-button
           type="text"
           size="small"
          @click="cancelChanges">
          <span v-if="_get(SysAdminInstanceDetails, 'saved')">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import { get } from 'lodash';
import { STATUS_INSTANCE_BLOCKED } from 'constants/status';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'components/mixins/form-standard-behavior';

export default {
  name: 'form-sys-admin-instance-block',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    SysAdminInstanceDetails: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    options: {
      type: Array,
      required: false,
      default: () => [
        {
          key: 'terms_violation',
          label: 'label.terms_violation',
          disabled: false,
        },
        {
          key: 'security_measure',
          label: 'label.security_measure',
          disabled: false,
        },
      ],
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        block: null,
        status_cause: null,
        status_comment: null,
      },
      rules: {
        status_cause: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.status', true),
          },
        ],
      },
    };
  },
  computed: {
    isBlocked() {
      return get(this.SysAdminInstanceDetails, 'data.status') === STATUS_INSTANCE_BLOCKED;
    },
  },
  methods: {
    setFormData() {
      this.formData.block = get(this.SysAdminInstanceDetails, 'data.status') === STATUS_INSTANCE_BLOCKED;
      this.formData.status_cause = get(this.SysAdminInstanceDetails, 'data.status_details.status_cause');
      this.formData.status_comment = get(this.SysAdminInstanceDetails, 'data.status_details.status_comment');
    },
    getFormData() {
      return this.isBlocked ? { block: false } : { block: true, status_cause: this.formData.status_cause, status_comment: this.formData.status_comment };
    },
  },
  created() {
    this.stateData = this.SysAdminInstanceDetails;
    this.formRef = 'form-sys-admin-instance-block';
    this.setFormData();
  },
  watch: {
    'SysAdminInstanceDetails.saved': {
      handler: function () {
        this.setFormData();
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/system-administration/instances/block/form-sys-admin-instance-block.vue